module.exports = __webpack_public_path__ + "img/deepcath.27b070ff.jpg";